export default "__VITE_ASSET__CTP2lPLN__"